export enum ContactsMode {
  ACD = 'ACD',
  CALL_CENTER_ADMIN = 'CALL_CENTER_ADMIN',
  CALL_CENTER_SUPERVISOR = 'CALL_CENTER_SUPERVISOR',
  CALL_CENTER_AGENT = 'CALL_CENTER_AGENT',
}
